import { useEffect, useRef, useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Checkbox, Drawer, Dropdown, Layout, Menu, Spin } from "antd";
import MediaQuery from "react-responsive";

import { CheckPermission } from "scripts/helpers";
import {
	openMenu,
	setRoute,
	updateSettings,
	updateTheme,
	updateUser,
} from "scripts/reducer";
import API from "scripts/api";
import Resources from "scripts/resources";
import Footer from "components/Footer";

const { Header, Sider, Content } = Layout;

const Component = ({
	onOpenMenu,
	onUpdateSettings,
	onUpdateTheme,
	onUpdateUser,
	openKey,
	routes,
	selectedKey,
	theme,
	user,
}) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { loaded, visible } = state;
	const { fullName, permissions, _theme } = user;
	const themeRef = useRef();

	const showDrawer = () => {
		setState((prevState) => ({ ...prevState, visible: true }));
	};

	const hideDrawer = () => {
		setState((prevState) => ({ ...prevState, visible: false }));
	};

	const handleMenu = ({ key }) => {
		onOpenMenu(openKey === key ? "" : key);
	};

	const handleLogout = () => {
		API.auth
			.logout()
			.then(() => {
				API.delCookie();
			})
			.catch(() => {});
	};

	const handleTheme = () => {
		onUpdateTheme(themeRef.current.state.checked ? "dark" : "light");
		API.setTheme(themeRef.current.state.checked ? "dark" : "light", 99999999);
	};

	const componentDidMount = () => {
		const token = API.getCookie();
		onUpdateTheme(API.getTheme());

		if (token) {
			API.auth
				.me()
				.then((user) => {
					if (user.permissions.length) {
						onUpdateUser(user);

						API.setting
							.details()
							.then(({ data }) => {
								onUpdateSettings({
									...data,
									currency:
										data.appCurrency === "T" ? Resources.toman : Resources.rial,
								});

								setState((prevState) => ({ ...prevState, loaded: true }));
							})
							.catch(() => {});
					} else {
						window.location = "/auth/login";
					}
				})
				.catch(() => {});
		} else {
			window.location = "/auth/login";
		}
	};

	useEffect(componentDidMount, []);

	const menu = (
		<>
			<Link to="/" className="sp-default-logo">
				<img
					src={`/images/${theme === "dark" ? "logo-white" : "logo-black"}.png`}
					alt={process.env.REACT_APP_CLIENT}
				/>
				{Resources.adminPanel}
			</Link>
			<Menu
				mode="inline"
				theme={theme === "dark" ? "dark" : "light"}
				items={routes
					.filter(
						(o) =>
							(o.component || o.routes) &&
							(!o.authority || CheckPermission(permissions, o.authority))
					)
					.map(({ icon, name, path, routes, title }) => {
						if (routes) {
							const _routes = routes.filter(
								(p) =>
									p.component &&
									(!p.authority || CheckPermission(permissions, p.authority))
							);

							if (_routes.length) {
								return {
									key: name,
									label: (
										<>
											{icon}
											{title}
										</>
									),
									children: _routes.map((o) => ({
										key: o.name,
										label: (
											<Link to={o.path}>
												{o.icon}
												{o.title}
											</Link>
										),
									})),
									onTitleClick: handleMenu,
								};
							}
						} else {
							return {
								key: name,
								label: (
									<Link to={path}>
										{icon}
										{title}
									</Link>
								),
								onClick: hideDrawer,
							};
						}
					})}
				selectedKeys={[selectedKey]}
				openKeys={[openKey]}
				className="sp-default-menu"
			/>
		</>
	);

	const headerMenu = {
		items: [
			// {
			// 	label: (
			// 		<>
			// 			<Checkbox
			// 				onChange={() => handleTheme()}
			// 				ref={themeRef}
			// 				defaultChecked={theme === "light"}
			// 			/>{" "}
			// 			{`${Resources.theme} ${Resources.light}`}
			// 		</>
			// 	),
			// 	key: "2",
			// },
			{
				label: (
					<>
						<i className="fa fa-sign-out" /> {Resources.logout}
					</>
				),
				key: "3",
				onClick: handleLogout,
			},
		],
	};

	return loaded ? (
		<Layout className={`sp-default-layout${theme === "dark" ? "" : " light"}`}>
			<MediaQuery minWidth={1200}>
				<Sider theme="light" width={220}>
					{menu}
				</Sider>
			</MediaQuery>
			<Layout>
				<Header>
					<MediaQuery maxWidth={1200}>
						<i className="drawer-trigger fa fa-bars" onClick={showDrawer} />
					</MediaQuery>
					<Dropdown
						menu={headerMenu}
						trigger={["click"]}
						overlayClassName="sp-default-dropdown"
					>
						<div>{fullName || ""}</div>
					</Dropdown>
				</Header>
				<Content>
					<Outlet />
				</Content>
				<Footer />
				<MediaQuery maxWidth={1200}>
					<Drawer
						open={visible}
						closable={false}
						onClose={hideDrawer}
						placement={process.env.REACT_APP_IS_RTL ? "right" : "left"}
						width={220}
						className={`sp-default-drawer${theme === "dark" ? "" : " light"}`}
					>
						{menu}
					</Drawer>
				</MediaQuery>
			</Layout>
		</Layout>
	) : (
		<Spin className="sp-center-spin" />
	);
};

export default connect(
	(state) => {
		return {
			selectedKey: state.selectedKey,
			openKey: state.openKey,
			theme: state.theme,
			user: state.user,
		};
	},
	(dispatch) => {
		return {
			onOpenMenu: (data) => dispatch(openMenu(data)),
			onSetRoute: (data) => dispatch(setRoute(data)),
			onUpdateSettings: (data) => dispatch(updateSettings(data)),
			onUpdateTheme: (data) => dispatch(updateTheme(data)),
			onUpdateUser: (data) => dispatch(updateUser(data)),
		};
	}
)(Component);
